export default "__VITE_ASSET__143764ff__"